"use client";

import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
export default function FrequentlyAskedQuestions() {
  const faqs = [{
    id: 1,
    question: "How long does a 3D modeling phase typically take?",
    answer: "For most residential projects, the 3D rendering and modeling phase takes approximately 1 to 2 weeks. This allows our craftsmen to precisely map your space and ensure every architectural detail is captured before construction begins."
  }, {
    id: 2,
    question: "Are you fully licensed and insured?",
    answer: "Yes, BT Remodeling is a fully licensed and insured general contractor serving the entire Denver metro area. We carry comprehensive liability and worker's compensation insurance to protect your investment and our team."
  }, {
    id: 3,
    question: "Do you handle the permitting process for additions and ADUs?",
    answer: "Absolutely. We manage the entire project lifecycle, including architectural drawings, structural engineering, and navigating the local Denver building department for all necessary permits and inspections."
  }, {
    id: 4,
    question: "What is your specialty in high-end remodeling?",
    answer: "We specialize in bespoke craftsmanship. Whether it's a custom kitchen remodel, a whole-home transformation, or a luxury outdoor living space with pergolas and epoxy coatings, our focus is on architectural precision and high-end finishes."
  }, {
    id: 5,
    question: "Can I see examples of your previous work in person?",
    answer: "We maintain an extensive portfolio of our Denver projects online. For serious inquiries, we can often arrange private viewings of completed projects or provide detailed references from our past high-end residential clients."
  }, {
    id: 6,
    question: "How do you ensure the project stays on budget?",
    answer: "Our detailed design-build process includes transparent line-item estimates and a fixed-price contract once the 3D modeling and material selections are finalized. This minimizes surprises and ensures your vision aligns with your investment."
  }];
  return <section data-section-id="237571" id="common-questions" className="w-full bg-background py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        {}
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl md:text-4xl font-bold font-default text-foreground tracking-tight">
            Common Questions
          </h2>
          <p className="text-base md:text-lg text-foreground/70 font-default">
            Insights into our architectural process and high-end remodeling standards at BT Remodeling.
          </p>
        </div>

        {}
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={`item-${faq.id}`} data-index={i} className="border border-border rounded-md overflow-hidden data-[state=open]:border-secondary shadow-sm hover:shadow-md transition-shadow bg-card">
              <AccordionTrigger className="px-5 md:px-6 hover:no-underline data-[state=open]:text-secondary data-[state=open]:bg-accent/10 transition-colors">
                <span className="text-right text-base md:text-lg font-semibold font-default text-foreground">
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="px-5 md:px-6 text-foreground/80 font-default leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        {}
        <div className="mt-12 text-center">
          <p className="mb-6 text-foreground/70 font-default">
            Have a specific project in mind?
          </p>
          <Link to="/StartYourProjectPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] bg-primary text-primary-foreground shadow-md hover:bg-primary/90 h-11 px-8 py-2 uppercase tracking-widest">
            Start Your Project
          </Link>
        </div>
      </div>
    </section>;
}